import React from 'react';
import { MessagesSquare } from 'lucide-react';
import LexiconPage from '../../pages/prioritization/lexicon/LexiconPage';

export const LexiconLab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-3">
          <MessagesSquare className="h-8 w-8 text-primary-600" />
          <h1 className="text-3xl font-bold text-charcoal-900">Lexicon (Lab)</h1>
        </div>
        <p className="text-charcoal-600 text-sm max-w-2xl mx-auto">
          Language intelligence from meeting transcripts — speaker profiles, communication patterns,
          and baseball-card views for how your team actually talks.
        </p>
      </div>
      <LexiconPage />
    </div>
  );
};
